import * as zod from 'zod';

import { Step } from '@sb/remote-control/types';
import { PayloadState } from '@sb/routine-runner/types/PayloadState';

export namespace DisableGripperStepDatabase {
  export const name = 'Disable gripper';
  export const description = 'Disable the currently enabled gripper';
  export const deviceKinds = undefined;
  export const librarySection = Step.LibrarySection.Basic;
  export const librarySort = '2';
  export const argumentKind = 'DisableGripper';

  export const Arguments = zod.object({
    argumentKind: zod.literal(argumentKind),
    payload: PayloadState.nullable().default(null),
  });

  export type Arguments = zod.infer<typeof Arguments>;

  export const toRoutineRunner: Step.ToRoutineRunner = ({
    stepConfiguration: { args },
    stepData,
  }) => {
    if (args?.argumentKind !== argumentKind) {
      throw new TypeError(`Expected argument kind ${argumentKind}`);
    }

    return {
      ...stepData,
      stepKind: 'DisableGripper',
      args: {
        payload: args.payload,
      },
    };
  };
}

DisableGripperStepDatabase satisfies Step.StepKindInfo;
